export const enCommon = {
  // SEO
  'seo.title.home': 'Review Management Software | Automate AI-powered Reviews | REPUTRUST',
  'seo.description.home': 'Automate your review management with AI-powered software. AI auto-reply for Google reviews, automatic social media sharing, and complete Google Business Profile management. 7-day free trial.',
  'seo.title.blog': 'Blog & Expert Knowledge | Online Reputation & Review Management | REPUTRUST',
  'seo.description.blog': 'Discover tips, best practices, and strategies to optimize your online reputation and increase customer reviews.',
  'seo.title.caseStudies': 'Success Stories & References | REPUTRUST',
  'seo.description.caseStudies': 'Learn how companies from various industries have improved their online reputation with REPUTRUST.',
  'seo.title.help': 'Help Center & Support | REPUTRUST',
  'seo.description.help': 'Browse our knowledge base or contact our support team.',
  'seo.title.webinars': 'Webinars & Online Training | REPUTRUST',
  'seo.description.webinars': 'Learn from experts how to optimize your review management.',
  'seo.title.legal': 'Legal Information | REPUTRUST',

  // Navigation
  'nav.blog': 'Blog',
  'nav.caseStudies': 'Case Studies',
  'nav.help': 'Help',
  'nav.login': 'Login',
  'nav.freeTrial': 'Free Trial',

  // Common
  'common.learnMore': 'Learn More',
  'common.getStarted': 'Get Started',
  'common.contactUs': 'Contact Us',

  // Hero Section
  'hero.badge': 'AI-powered Review Automation',
  'hero.title': 'Your automated',
  'hero.titleHighlight': 'Review Agent',
  'hero.subtitle': 'AI-powered responses, social media automation, and complete management of your Google Business Profile.',
  'hero.benefit1': 'Automatic AI responses to all reviews',
  'hero.benefit2': 'Automatically generate social media posts',
  'hero.benefit3': 'Centrally manage Google Business Profile',
  'hero.ctaPrimary': 'Try for Free',
  'hero.ctaSecondary': 'Watch Live Demo',
  'hero.trustCustomers': 'satisfied customers',
  'hero.trustRating': 'rating',
  'hero.dashboardTitle': 'Dashboard',
  'hero.dashboardPeriod': 'Last 30 Days',
  'hero.stat1': 'Reviews Answered',
  'hero.stat2': 'Social Posts Created',
  'hero.activity1': '5★ Review automatically answered',
  'hero.activity1Time': '2 minutes ago',
  'hero.activity2': 'Instagram post published',
  'hero.activity2Time': '15 minutes ago',
  'hero.statusActive': 'All systems active',

  // Problem Section
  'problem.badge': 'The Challenge',
  'problem.title': 'Why Review Management',
  'problem.titleHighlight': 'is Crucial',
  'problem.subtitle': 'Google\'s new updates make reputation a ranking factor. Without active review management, you lose visibility and customers.',
  'problem.problem1.title': 'Time-Consuming Responses',
  'problem.problem1.desc': 'Manually responding to every review takes valuable time you need for your core business.',
  'problem.problem1.stat': 'Up to 2 hours daily',
  'problem.problem2.title': 'Google Ranking Loss',
  'problem.problem2.desc': 'Google\'s new updates evaluate your reputation. Few or unanswered reviews drastically reduce your visibility.',
  'problem.problem2.stat': 'Up to 40% less visibility',
  'problem.problem3.title': 'Too Few Reviews',
  'problem.problem3.desc': 'Without active review generation, positive customer experiences remain invisible and your reputation stagnates.',
  'problem.problem3.stat': '85% of customers read reviews',
  'problem.problem4.title': 'Negative Reviews',
  'problem.problem4.desc': 'Unanswered negative reviews damage your image and deter potential customers.',
  'problem.problem4.stat': '30% revenue loss possible',
  'problem.problem5.title': 'Missing Social Media Presence',
  'problem.problem5.desc': 'Positive reviews are not used for social media, resulting in lost valuable marketing opportunities.',
  'problem.problem5.stat': 'Missed reach',
  'problem.problem6.title': 'Weak Online Reputation',
  'problem.problem6.desc': 'Without continuous review generation and maintenance, you lose against competitors with better reputation.',
  'problem.problem6.stat': 'Competition overtakes you',
  'problem.impact.title': 'The Cost of Poor Review Management',
  'problem.impact.subtitle': 'Google\'s new algorithm updates make reputation the decisive ranking factor',
  'problem.impact.stat1': '40%',
  'problem.impact.stat1.desc': 'less Google visibility without good reputation',
  'problem.impact.stat2': '2h',
  'problem.impact.stat2.desc': 'daily for manual review management',
  'problem.impact.stat3': '85%',
  'problem.impact.stat3.desc': 'of customers read reviews before purchase',
  'problem.impact.stat4': '30%',
  'problem.impact.stat4.desc': 'revenue loss from negative reviews',

  // Solution Section
  'solution.badge': 'The Solution',
  'solution.title': 'Automated',
  'solution.titleHighlight': 'Review Management',
  'solution.subtitle': 'Our AI handles everything for you - from responses to social media',
  'solution.module1.feature1': 'Natural Language',
  'solution.module1.feature2': 'Adjustable Tonality',
  'solution.module1.feature3': '24/7 Available',
  'solution.module1.feature4': 'Google Optimized',
  'solution.module2.feature1': 'Automatic Email Campaigns',
  'solution.module2.feature2': 'SMS Reminders',
  'solution.module2.feature3': 'QR Code Generator',
  'solution.module2.feature4': 'Timing Optimization',
  'solution.module3.feature1': 'Instagram & Facebook',
  'solution.module3.feature2': 'Automatic Planning',
  'solution.module3.feature3': 'Optimized Hashtags',
  'solution.module3.feature4': 'Story Templates',
  'solution.module4.feature1': 'Multi-Location Support',
  'solution.module4.feature2': 'Ranking Tracking',
  'solution.module4.feature3': 'Competitor Analysis',
  'solution.module4.feature4': 'SEO Optimization',
  'solution.module1.title': 'AI Review Agent',
  'solution.module1.desc': 'Our AI responds to every review individually, professionally, and in record time.',
  'solution.module2.title': 'Review Boost',
  'solution.module2.desc': 'Systematically generate more positive reviews via email, SMS, and QR codes.',
  'solution.module3.title': 'Social Media Automation',
  'solution.module3.desc': 'Automatically transform positive reviews into attractive social media posts.',
  'solution.module4.title': 'Google Business Manager',
  'solution.module4.desc': 'Central management of all Google Business Profiles and locations in one dashboard.',
  'solution.stat1': 'Time Savings',
  'solution.stat2': 'More Reviews',
  'solution.stat3': 'Google Visibility',
  'solution.stat4': 'Availability',

  // Testimonials Section
  'testimonials.badge': 'Success Stories',
  'testimonials.title': 'What our',
  'testimonials.titleHighlight': 'customers say',
  'testimonials.subtitle': 'Over 2,500 businesses trust our platform',
  'testimonials.testimonial1.text': 'Since using REPUTRUST, we save 2 hours daily. The AI responses are perfect and our ratings have improved by 40%!',
  'testimonials.testimonial1.author': 'Dr. Sarah Mueller',
  'testimonials.testimonial1.role': 'Dentist',
  'testimonials.testimonial1.company': 'Dental Clinic Munich',
  'testimonials.testimonial2.text': 'The automatic social media posts are brilliant! Our reach has tripled and we are getting significantly more reservations.',
  'testimonials.testimonial2.author': 'Michael Weber',
  'testimonials.testimonial2.role': 'CEO',
  'testimonials.testimonial2.company': 'Restaurant Bella Vista',
  'testimonials.testimonial3.text': 'Finally we have all reviews under control. The dashboard is clear and the automations work perfectly. Absolute recommendation!',
  'testimonials.testimonial3.author': 'Anna Schmidt',
  'testimonials.testimonial3.role': 'Marketing Manager',
  'testimonials.testimonial3.company': 'Fitness Studio Hamburg',
  'testimonials.trustRate': 'Active Customers',
  'testimonials.managed': 'Reviews Managed',
  'testimonials.satisfaction': 'Customer Satisfaction',
  'testimonials.avgRating': 'Average Rating',

  // CTA Section
  'cta.badge': 'Get Started Now',
  'cta.title': 'Ready for automated',
  'cta.titleHighlight': 'review management?',
  'cta.subtitle': 'Start your 7-day free trial today - no credit card required',
  'cta.benefit1': '7-day free trial',
  'cta.benefit2': 'No credit card required',
  'cta.benefit3': 'Cancel anytime',
  'cta.benefit4': 'Setup in 5 minutes',
  'cta.ctaPrimary': 'Start Free Trial',
  'cta.ctaSecondary': 'Schedule Demo',

  // Footer
  'footer.tagline': 'Your automated Review Agent',
  'footer.description': 'AI-powered review management, social media automation, and complete control over your Google Business Profile.',
  'footer.product': 'Product',
  'footer.features': 'Features',
  'footer.pricing': 'Pricing',
  'footer.caseStudies': 'Case Studies',
  'footer.webinars': 'Webinars',
  'footer.company': 'Company',
  'footer.about': 'About Us',
  'footer.blog': 'Blog',
  'footer.careers': 'Careers',
  'footer.contact': 'Contact',
  'footer.support': 'Support',
  'footer.helpCenter': 'Help Center',
  'footer.documentation': 'Documentation',
  'footer.apiDocs': 'API Documentation',
  'footer.status': 'System Status',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.imprint': 'Imprint',
  'footer.cookies': 'Cookie Policy',
  'footer.copyright': '© {{year}} reputrust.ai – All rights reserved',
  'header.contactSupport': "Questions? We're happy to help!",
  'footer.madeWith': 'Made with',
  'footer.in': 'in',
  'footer.location': 'Germany',

  // Features Section
  'features.badge': 'More Features',
  'features.title': 'Everything you',
  'features.titleHighlight': 'need',
  'features.subtitle': 'A complete platform for professional review management',
  'features.feature1.title': 'Google Business Integration',
  'features.feature1.desc': 'Direct access to your Google Business Profile',
  'features.feature2.title': 'Detailed Analytics',
  'features.feature2.desc': 'Comprehensive statistics and insights',
  'features.feature3.title': 'Multi-User Support',
  'features.feature3.desc': 'Team management with roles and permissions',
  'features.feature4.title': 'Real-time Notifications',
  'features.feature4.desc': 'Instant alerts for new reviews',
  'features.feature5.title': 'GDPR Compliant',
  'features.feature5.desc': 'Highest security and privacy standards',
  'features.feature6.title': 'Premium Support',
  'features.feature6.desc': 'Personal support via chat, email & phone',

  // Pricing Section
  'pricing.badge': 'Pricing',
  'pricing.title': 'Transparent',
  'pricing.titleHighlight': 'Pricing',
  'pricing.subtitle': 'Choose the perfect plan for your business',
  'pricing.monthly': 'Monthly',
  'pricing.annually': 'Annually',
  'pricing.discount': '-20%',
  'pricing.perMonth': '/month',
  'pricing.billedAnnually': 'Billed annually',
  'pricing.year': '/year',
  'pricing.popularBadge': 'Most Popular',
  'pricing.business.name': 'Business',
  'pricing.business.desc': 'For growing businesses',
  'pricing.business.feature2': 'AI Review Agent',
  'pricing.business.feature3': 'AI Auto-Share (Instagram & Facebook)',
  'pricing.business.feature4': 'Google Business Manager',
  'pricing.business.feature5': 'Monthly Email: Unlimited',
  'pricing.business.feature6': 'Advanced Analytics',
  'pricing.business.feature7': 'Multi-Location Support',
  'pricing.enterprise.name': 'Enterprise',
  'pricing.enterprise.desc': 'For large organizations',
  'pricing.enterprise.feature2': 'All Business Features',
  'pricing.enterprise.feature3': 'Custom AI Training',
  'pricing.enterprise.feature4': 'Dedicated Account Manager',
  'pricing.enterprise.feature5': 'API Access',
  'pricing.enterprise.feature6': 'Custom Integrations',
  'pricing.enterprise.feature7': 'Monthly SMS: 150+',
  'pricing.enterprise.feature8': 'Monthly WhatsApp: 150+',
  'pricing.enterprise.feature9': 'Multi-Location Support',
  'pricing.cta': 'Get Started',
  'pricing.note': 'All plans include a',
  'pricing.noteBold': '7-day free trial',
  'pricing.noteEnd': 'without credit card',

  // Dashboard Preview Section
  'dashboard.badge': 'Powerful Dashboard',
  'dashboard.title': 'Your',
  'dashboard.titleHighlight': 'Control Center',
  'dashboard.subtitle': 'All reviews, automations, and analytics in one place – clear, intuitive, and powerful',
  'dashboard.nav.dashboard': 'Dashboard',
  'dashboard.nav.reviews': 'Reviews',
  'dashboard.nav.requests': 'Requests',
  'dashboard.nav.shared': 'Shared',
  'dashboard.nav.widgets': 'Widgets',
  'dashboard.nav.googleProfile': 'Profile',
  'dashboard.nav.aiAgent': 'AI Agent',
  'dashboard.nav.settings': 'Settings',
  'dashboard.home.nav.overview': 'Overview',
  'dashboard.home.nav.performance': 'Performance',
  'dashboard.home.nav.sentiment': 'Sentiment',
  'dashboard.home.nav.competitors': 'Competitors',
  'dashboard.welcome': 'Welcome back! Here\'s your overview.',
  'dashboard.search': 'Search...',
  'dashboard.mock.company': 'Your Company',
  'dashboard.mock.domain': 'yourcompany.com',
  'dashboard.mock.connected': 'Connected and synchronized',
  'dashboard.mock.manage': 'Manage Settings',
  'dashboard.stat1.label': 'Avg Rating',
  'dashboard.stat1.change': '+0.3',
  'dashboard.stat2.label': 'Response Rate',
  'dashboard.stat2.change': '+12%',
  'dashboard.stat3.label': 'Social Posts',
  'dashboard.stat3.change': '+45',
  'dashboard.activity.title': 'Recent Activity',
  'dashboard.activity1.name': 'Sarah M.',
  'dashboard.activity1.action': 'New 5★ Review',
  'dashboard.activity1.time': '2 Min',
  'dashboard.activity1.status': 'Answered',
  'dashboard.activity2.name': 'Michael K.',
  'dashboard.activity2.action': 'Review shared',
  'dashboard.activity2.time': '15 Min',
  'dashboard.activity2.status': 'Shared',
  'dashboard.activity3.name': 'Anna B.',
  'dashboard.activity3.action': 'New 5★ Review',
  'dashboard.activity3.time': '1 Hr',
  'dashboard.activity3.status': 'Answered',
  'dashboard.activity4.name': 'Thomas W.',
  'dashboard.activity4.action': 'Campaign sent',
  'dashboard.activity4.time': '2 Hrs',
  'dashboard.activity4.status': 'Sent',
  'dashboard.modules.title': 'AI Modules',
  'dashboard.module1.name': 'Auto-Reply',
  'dashboard.module1.desc': 'Automatic review responses',
  'dashboard.module2.name': 'Auto-Share',
  'dashboard.module2.desc': 'Social media automation',
  'dashboard.module3.name': 'Auto-Campaigns',
  'dashboard.module3.desc': 'Send review requests',
  'dashboard.modules.cta': 'Configure Modules',

  // Dashboard - Stats
  'dashboard.stats.aggregatedReviews': 'Aggregated Reviews',
  'dashboard.stats.privateFeedback': 'Private Feedback',
  'dashboard.stats.reviews': 'Reviews',
  'dashboard.stats.rating': 'Rating',
  'dashboard.stats.goal': '5-star reviews to 4.9!',

  // Dashboard - Reviews
  'dashboard.reviews.title': 'Reviews',
  'dashboard.reviews.filter': 'Filter',
  'dashboard.reviews.quickRequest': 'Quick Request',
  'dashboard.reviews.review1.text': 'We were thrilled! The team is absolutely top-notch in expertise, reliability, and customer orientation...',
  'dashboard.reviews.review1.reply': 'Thank you for your wonderful review! We are very pleased that you are satisfied with our service.',
  'dashboard.reviews.review2.text': 'Everything super! Thanks!',
  'dashboard.reviews.review2.reply': 'Glossed to hear that, thanks! Hope to see you again soon. 😊',
  'dashboard.reviews.review3.text': 'Top service, happily again.',
  'dashboard.reviews.review3.reply': 'Thanks Carsten!',
  'dashboard.reviews.editReply': 'Edit Reply',
  'dashboard.reviews.deleteReply': 'Delete Reply',
  'dashboard.reviews.review1.date': 'May 11 2025',
  'dashboard.reviews.review1.replyDate': '22 Jan',
  'dashboard.reviews.review2.date': 'February 29 2024',
  'dashboard.reviews.review2.replyDate': '19 Apr',
  'dashboard.reviews.review3.date': 'July 20 2023',
  'dashboard.reviews.review3.replyDate': '21 Jul',

  // Dashboard - Requests
  'dashboard.requests.title': 'Requests',
  'dashboard.requests.send': 'Send',
  'dashboard.requests.templates': 'Templates',
  'dashboard.requests.contacts': 'Contacts',
  'dashboard.requests.optIn': 'Opt-In',
  'dashboard.requests.autoCampaign': 'Auto-Campaign',
  'dashboard.requests.newTemplate': 'New Template',
  'dashboard.requests.active': 'Active',
  'dashboard.requests.channel': 'Channel',
  'dashboard.requests.email': 'Email',
  'dashboard.requests.preview': 'Preview',
  'dashboard.requests.success': 'Template successfully created',
  'dashboard.requests.campaignNameMock': 'Review Campaign...',
  'dashboard.requests.dateMock': 'February 12',

  // Dashboard - Shared
  'dashboard.shared.title': 'Start Sharing Your Reviews',
  'dashboard.shared.desc': 'Highlight your happiest customers by publishing your 4 and 5-star reviews on social media. Simply press the "Share" button and immediately build more trust.',
  'dashboard.shared.cta': 'Go to Reviews',

  // Dashboard - Widgets
  'dashboard.widgets.title': 'Website Widgets',
  'dashboard.widgets.carousel.title': 'Review Carousel',
  'dashboard.widgets.carousel.desc': 'Showcase your best reviews in an elegant slider.',
  'dashboard.widgets.list.title': 'Review List',
  'dashboard.widgets.list.desc': 'Display all reviews in a clean list.',
  'dashboard.widgets.badge.title': 'Review Badge',
  'dashboard.widgets.badge.desc': 'A compact badge showing your overall rating.',
  'dashboard.widgets.popup.title': 'Popup Notification',
  'dashboard.widgets.popup.desc': 'Show new reviews live as a popup.',
  'dashboard.widgets.preview': 'Preview',
  'dashboard.widgets.install': 'Install',

  // Dashboard - Profile (Google)
  'dashboard.profile.performance': 'Performance Overview',
  'dashboard.profile.views': 'Views (Maps)',
  'dashboard.profile.clicks': 'Website Clicks',
  'dashboard.profile.calls': 'Calls',
  'dashboard.profile.thisMonth': 'this month',

  // Dashboard - AI Agent
  'dashboard.ai.title': 'AI Reply Assistant',
  'dashboard.ai.subtitle': 'Configure how the AI responds to your reviews.',
  'dashboard.ai.autoReply': 'Auto-Reply',
  'dashboard.ai.tonality': 'Tonality',
  'dashboard.ai.tone.professional': 'Professional',
  'dashboard.ai.tone.friendly': 'Friendly',
  'dashboard.ai.tone.empathic': 'Empathic',
  'dashboard.ai.tone.example': 'Example response text...',
  'dashboard.ai.signature': 'Signature',
  'dashboard.ai.signature.placeholder': 'Sincerely,\nYour YourCompany Team',

  // Dashboard - Settings
  'dashboard.settings.title': 'Settings',
  'dashboard.settings.general': 'General',
  'dashboard.settings.notifications': 'Notifications',
  'dashboard.settings.team': 'Team',
  'dashboard.settings.billing': 'Billing',
  'dashboard.settings.integrations': 'Integrations',
  'dashboard.settings.generalInfo': 'General Information',
  'dashboard.settings.companyName': 'Company Name',
  'dashboard.settings.website': 'Website',
  'dashboard.settings.save': 'Save Changes',
  'dashboard.footer': 'Optimized for Desktop, Tablet and Mobile',

  // Blog Page
  'blog.badge': 'Blog & Resources',
  'blog.title': 'Review Management Expert Knowledge',
  'blog.subtitle': 'Discover tips, best practices, and strategies to optimize your online reputation and increase your customer reviews.',
  'blog.categories.all': 'All',
  'blog.categories.reviewManagement': 'Review Management',
  'blog.categories.technology': 'Technology',
  'blog.categories.marketing': 'Marketing',
  'blog.categories.seoLocal': 'SEO & Local Marketing',
  'blog.categories.customerService': 'Customer Service',
  'blog.categories.legal': 'Legal & Compliance',
  'blog.readMore': 'Read More',
  'blog.loadMore': 'Load More Articles',
  'blog.newsletter.title': 'Stay Updated',
  'blog.newsletter.subtitle': 'Get the latest articles, tips, and updates delivered straight to your inbox.',
  'blog.newsletter.placeholder': 'Your email address',
  'blog.newsletter.cta': 'Subscribe',
  'blog.readTime': 'min read',

  // Case Studies Page
  'caseStudies.badge': 'Success Stories',
  'caseStudies.title': 'Case Studies: Successful Customers',
  'caseStudies.subtitle': 'Learn how businesses from various industries have improved their online reputation and achieved measurable success with reputrust.ai.',
  'caseStudies.stats.customers.value': '500+',
  'caseStudies.stats.customers.label': 'Satisfied Customers',
  'caseStudies.stats.increase.value': '+187%',
  'caseStudies.stats.increase.label': 'Avg Rating Increase',
  'caseStudies.stats.rating.value': '4.8',
  'caseStudies.stats.rating.label': 'Avg Customer Rating',
  'caseStudies.stats.recommendation.value': '98%',
  'caseStudies.stats.recommendation.label': 'Recommendation Rate',
  'caseStudies.challenge': 'CHALLENGE',
  'caseStudies.solution': 'SOLUTION',
  'caseStudies.duration': 'Duration:',
  'caseStudies.cta.title': 'Become Our Next Success Story',
  'caseStudies.cta.subtitle': 'Start now with your 7-day free trial and experience for yourself how reputrust.ai can advance your business.',
  'caseStudies.cta.primary': 'Try for Free',
  'caseStudies.cta.secondary': 'Book Demo',

  // Case Study 1
  'caseStudies.item1.company': 'Dr. med. Klaus Weidinger',
  'caseStudies.item1.industry': 'Medical Practice',
  'caseStudies.item1.challenge': 'Too few online reviews and no systematic review generation',
  'caseStudies.item1.solution': 'Implementation of QR codes in the waiting room and automated email campaigns after appointments',
  'caseStudies.item1.results.res1.metric': '+287%',
  'caseStudies.item1.results.res1.label': 'More Reviews',
  'caseStudies.item1.results.res2.metric': '4.9',
  'caseStudies.item1.results.res2.label': 'Average Rating',
  'caseStudies.item1.results.res3.metric': '+156%',
  'caseStudies.item1.results.res3.label': 'New Patients',
  'caseStudies.item1.testimonial': 'Since using reputrust.ai, we have significantly more positive reviews. The platform is easy to use and saves us a lot of time.',
  'caseStudies.item1.duration': '6 Months',

  // Case Study 2
  'caseStudies.item2.company': 'Restaurant Bella Vista',
  'caseStudies.item2.industry': 'Gastronomy',
  'caseStudies.item2.challenge': 'Negative reviews on multiple platforms and no time for professional responses',
  'caseStudies.item2.solution': 'AI-powered automatic responses and review filters to avoid negative public reviews',
  'caseStudies.item2.results.res1.metric': '+92%',
  'caseStudies.item2.results.res1.label': 'Positive Reviews',
  'caseStudies.item2.results.res2.metric': '-78%',
  'caseStudies.item2.results.res2.label': 'Negative Reviews',
  'caseStudies.item2.results.res3.metric': '+43%',
  'caseStudies.item2.results.res3.label': 'Reservations',
  'caseStudies.item2.testimonial': 'The AI response function is fantastic! We save hours daily and our responses are always professional and friendly.',
  'caseStudies.item2.duration': '4 Months',

  // Case Study 3
  'caseStudies.item3.company': 'Immobilien Weber GmbH',
  'caseStudies.item3.industry': 'Real Estate',
  'caseStudies.item3.challenge': 'Low social media presence and no use of customer reviews for marketing',
  'caseStudies.item3.solution': 'Automatic social media posts with positive reviews and CI-compliant graphics',
  'caseStudies.item3.results.res1.metric': '+340%',
  'caseStudies.item3.results.res1.label': 'Social Media Reach',
  'caseStudies.item3.results.res2.metric': '+125%',
  'caseStudies.item3.results.res2.label': 'Website Visitors',
  'caseStudies.item3.results.res3.metric': '+89%',
  'caseStudies.item3.results.res3.label': 'Inquiries',
  'caseStudies.item3.testimonial': 'The automatic social media integration has completely changed our online presence. We now reach many more potential customers.',
  'caseStudies.item3.duration': '8 Months',

  // Case Study 4
  'caseStudies.item4.company': 'Autohaus Müller & Söhne',
  'caseStudies.item4.industry': 'Automotive Trade',
  'caseStudies.item4.challenge': 'Multiple locations without central review management and inconsistent Google profiles',
  'caseStudies.item4.solution': 'Central dashboard for all locations with uniform review management and Google Business Profile management',
  'caseStudies.item4.results.res1.metric': '+215%',
  'caseStudies.item4.results.res1.label': 'Total Reviews',
  'caseStudies.item4.results.res2.metric': '100%',
  'caseStudies.item4.results.res2.label': 'Profile Completeness',
  'caseStudies.item4.results.res3.metric': '+67%',
  'caseStudies.item4.results.res3.label': 'Sales Inquiries',
  'caseStudies.item4.testimonial': 'Finally, we have all locations centrally in view. Management has become so much easier and our Google profiles are perfectly optimized.',
  'caseStudies.item4.duration': '5 Months',

  // Case Study 5
  'caseStudies.item5.company': 'Fitness Studio PowerGym',
  'caseStudies.item5.industry': 'Fitness & Wellness',
  'caseStudies.item5.challenge': 'High member fluctuation and little feedback to improve the offering',
  'caseStudies.item5.solution': 'Automated review requests after trial sessions and internal feedback system for negative experiences',
  'caseStudies.item5.results.res1.metric': '+178%',
  'caseStudies.item5.results.res1.label': 'Member Feedback',
  'caseStudies.item5.results.res2.metric': '-45%',
  'caseStudies.item5.results.res2.label': 'Cancellation Rate',
  'caseStudies.item5.results.res3.metric': '+112%',
  'caseStudies.item5.results.res3.label': 'New Members',
  'caseStudies.item5.testimonial': 'We now understand much better what our members want. The feedback helps us to continuously improve our offering.',
  'caseStudies.item5.duration': '7 Months',

  // Case Study 6
  'caseStudies.item6.company': 'Hotel Alpenblick',
  'caseStudies.item6.industry': 'Hospitality',
  'caseStudies.item6.challenge': 'Reviews on over 10 different platforms without a central overview',
  'caseStudies.item6.solution': 'Central review management for all platforms with automatic responses and analysis dashboard',
  'caseStudies.item6.results.res1.metric': '+95%',
  'caseStudies.item6.results.res1.label': 'Response Rate',
  'caseStudies.item6.results.res2.metric': '4.8',
  'caseStudies.item6.results.res2.label': 'Average Rating',
  'caseStudies.item6.results.res3.metric': '+134%',
  'caseStudies.item6.results.res3.label': 'Direct Bookings',
  'caseStudies.item6.testimonial': 'The central management of all review platforms saves us several hours daily. We can now react much faster to guest feedback.',
  'caseStudies.item6.duration': '6 Months',

  // Help Center Page
  'help.badge': 'Help & Support',
  'help.title': 'How can we help you?',
  'help.subtitle': 'Browse our knowledge base or contact our support team',
  'help.search.placeholder': 'Search for answers...',
  'help.quickLinks.documentation': 'Documentation',
  'help.quickLinks.documentationDesc': 'Complete guides',
  'help.quickLinks.videos': 'Video Tutorials',
  'help.quickLinks.videosDesc': 'Step-by-step videos',
  'help.quickLinks.support': 'Contact Support',
  'help.quickLinks.supportDesc': 'We\'re happy to help',
  'help.quickLinks.demo': 'Book Demo',
  'help.quickLinks.demoDesc': 'Personal product demonstration',
  'help.faq.title': 'Frequently Asked Questions',
  'help.faq.subtitle': 'Find quick answers to the most important questions',
  'help.categories.gettingStarted': 'Getting Started',
  'help.categories.reviewManagement': 'Review Management',
  'help.categories.aiResponse': 'AI Auto-Reply',
  'help.categories.socialMedia': 'Social Media Integration',
  'help.categories.googleBusiness': 'Google Business Management',
  'help.categories.pricing': 'Pricing & Billing',
  'help.faq.q1': 'How do I register with reputrust.ai?',
  'help.faq.a1': 'Registration is easy: Click on \'Free Trial\', enter your company details and select a pricing model. After confirming your email address, you can start immediately.',
  'help.faq.q2': 'How long does the setup take?',
  'help.faq.a2': 'The basic setup takes only 5-10 minutes. Our onboarding assistant will guide you through all the important steps. For advanced features like API integrations, we are happy to assist you.',
  'help.faq.q3': 'Can I test the platform before purchasing?',
  'help.faq.a3': 'Yes! We offer a 7-day free trial period. You can use all functions without restrictions, without providing payment information.',
  'help.faq.q4': 'How do I generate reviews with QR codes?',
  'help.faq.a4': 'Create a QR code in your dashboard that leads directly to your review form. Print it out or display it digitally. Customers scan the code and can immediately leave a review.',
  'help.faq.q5': 'How does the review filter work?',
  'help.faq.a5': 'Our intelligent filter directs customers with 1-3 stars to an internal feedback form, while 4-5 star reviews are forwarded directly to Google, Facebook or other platforms.',
  'help.faq.q6': 'On which platforms can I collect reviews?',
  'help.faq.a6': 'We support over 20 platforms, including Google, Facebook, Trustpilot, TripAdvisor, Amazon, eBay, Airbnb and many more.',
  'help.faq.q7': 'How does the AI-powered response function work?',
  'help.faq.a7': 'Our AI analyzes every review and automatically generates a suitable, professional response in the desired tone. You can set the tone (friendly, professional, humorous) and language individually.',
  'help.faq.q8': 'Can I review the AI responses before they are sent?',
  'help.faq.a8': 'Yes, you have full control. You can choose whether responses should be sent automatically or presented for review.',
  'help.faq.q9': 'In which languages does the AI response work?',
  'help.faq.a9': 'The AI supports over 30 languages, including German, English, French, Spanish, Italian and many more. The language is automatically detected.',
  'help.faq.q10': 'How does automatic social media posting work?',
  'help.faq.a10': 'Positive reviews (4-5 stars) are automatically shared as appealing posts with CI-compliant graphics on Instagram, Facebook and LinkedIn. The AI generates suitable texts.',
  'help.faq.q11': 'Can I edit the posts before publishing?',
  'help.faq.a11': 'Yes, you can review and adjust every post before publishing. Alternatively, you can activate fully automatic publishing.',
  'help.faq.q12': 'Which social media platforms are supported?',
  'help.faq.a12': 'We currently support Instagram, Facebook and LinkedIn. Further platforms are planned.',
  'help.faq.q13': 'How do I connect my Google Business Profile?',
  'help.faq.a13': 'Go to Settings > Integrations > Google Business Profile and follow the authentication process. The connection is established in just a few minutes.',
  'help.faq.q14': 'What features does Google Business Management offer?',
  'help.faq.a14': 'You can manage opening hours, upload photos, create posts, view statistics and respond to reviews – all centrally in one dashboard.',
  'help.faq.q15': 'Can I manage multiple locations?',
  'help.faq.a15': 'Yes, with our Business and Enterprise plan you can manage multiple locations centrally.',
  'help.faq.q16': 'What payment methods are accepted?',
  'help.faq.a16': 'We accept credit cards (Visa, Mastercard, American Express), SEPA direct debit and PayPal.',
  'help.faq.q17': 'Can I cancel at any time?',
  'help.faq.a17': 'Yes, you can cancel at any time with a notice period of one month to the end of the billing period. There are no hidden costs or cancellation fees.',
  'help.faq.q18': 'Are there discounts for annual payment?',
  'help.faq.a18': 'Yes, with annual payment you get 2 months free (corresponds to approx. 17% discount).',
  'help.contact.title': 'Still have questions?',
  'help.contact.subtitle': 'Our support team is happy to assist you',
  'help.contact.email': 'Send Email',
  'help.contact.phone': '07026-39999 88',

  // Webinars Page
  'webinars.badge': 'Live & On-Demand',
  'webinars.title': 'Webinars & Online Training',
  'webinars.subtitle': 'Learn from experts how to optimize your review management and sustainably improve your online reputation.',
  'webinars.upcoming.title': 'Upcoming Webinars',
  'webinars.upcoming.subtitle': 'Register now and secure your spot',
  'webinars.past.title': 'Webinar Recordings',
  'webinars.past.subtitle': 'Watch past webinars anytime',
  'webinars.level.beginner': 'Beginner',
  'webinars.level.advanced': 'Advanced',
  'webinars.attendees': 'Attendees',
  'webinars.topics': 'TOPICS:',
  'webinars.register': 'Register Now',
  'webinars.duration': 'Min.',
  'webinars.views': 'Views',
  'webinars.newsletter.title': 'Never Miss a Webinar',
  'webinars.newsletter.subtitle': 'Subscribe to our newsletter and receive notifications about new webinars',
  'webinars.newsletter.placeholder': 'Your email address',
  'webinars.newsletter.cta': 'Subscribe',

  // Blog Article Page
  'article.share': 'Share:',
  'article.backToBlog': 'Back to Blog',
  'article.relatedArticles': 'Related Articles',
  'article.notFound.title': 'Article Not Found',
  'article.notFound.description': 'The requested article could not be found.',
  'article.notFound.cta': 'Back to Blog',
};

export default enCommon;
